import { render } from "./ReferralCodePage.vue?vue&type=template&id=4f6ab912"
import script from "./ReferralCodePage.vue?vue&type=script&lang=js"
export * from "./ReferralCodePage.vue?vue&type=script&lang=js"

import "./ReferralCodePage.vue?vue&type=style&index=0&id=4f6ab912&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__